'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './faq-edit.routes';

export class FAQEditComponent {

  constructor(Auth, dialogs, SettingsService, $uibModal, $state, $stateParams, $location, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;
    this.SettingsService = SettingsService;

    this.faqCategory = $stateParams.name;
    //this.boardAndStuffSettingName = directoriesConfig.getBoardAndStaffSetting() || 'board-and-staff';

    SettingsService.getByName({name: this.faqCategory}, setting => {
      this.setting = setting;
      this.sections = setting.data;
    }, err => {
    });

    this.sortableOptions = {
        handle: '.handle'
    };

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

  }

  addSection() {

    this.sections.push({
      question: '',
      answer: ''
    });
  }

  deleteSection($event, section, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Entry?", "Do you really want to delete the entry '" + section.question + "'?");
    dlg.result.then(() => {
      this.sections.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {

    this.setting.data = this.sections;

    var onSuccess = (data) => {
      this.dialogs.notify("Success", "Changes have been saved successfully");
    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    this.SettingsService.update({id: this.setting._id}, this.setting, onSuccess, onError);
  }

}

export default angular.module('conduuApp.faqEdit', [uiRouter])
  .config(routes)
  .component('faqEdit', {
    template: require('./faq-edit.html'),
    controller: FAQEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/faq/edit/faq-edit.component.js